<template>
  <div class="fei-shu-login">
    <!-- 飞书授权登录页面，无需展示内容 -->
  </div>
</template>

<script>
import { getFeiShuLoginConfiguration ,getFeiShuLoginOauth} from "@/api/index.js";

export default {
  name: "FeiShuLogin",
  created() {
        // 添加飞书授权代码
     const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get('code') || '';
    this.state = urlParams.get('state') || '';
    
    var token = localStorage.getItem("token");
    console.log('token=========',token)
    if(this.code && token==null){
      //飞书文档认证
      getFeiShuLoginOauth({
        code: this.code,
        state: this.state,
      }).then((res) => {
        console.log('feishulogin====res', res);
        if (res.code == 200) {
          localStorage.setItem("token", res.data.token);
          this.nickname = res.data.nickname;
          console.log('token2=========',res.data.token)
          localStorage.setItem("nickname", res.data.userInfo.nickname);
          localStorage.setItem("ifFeiShuDocs", res.data.userInfo.ifFeiShuDocs);
          localStorage.setItem("feishuDocsExpiry", res.data.userInfo.feishuDocsExpiry);
          localStorage.setItem("isFeiShuLogin", 1);
          localStorage.setItem("openId", res.data.userInfo.openidId);
          setTimeout(() => {
            window.location.href = "/create"; // 修改这行代码，在当前页面跳转
          }, 1000);
        }
        return;
      })
      .catch((err) => {
        console.log("err", err);
      })
    }

    if(token==null){
        // 页面加载时自动调用飞书授权接口
        this.handleFeiShuAuth();
    }else{
      setTimeout(() => {
        window.location.href = "/create"; // 修改这行代码，在当前页面跳转
      }, 1000);
    }

  },
  methods: {
    handleFeiShuAuth() {
        getFeiShuLoginConfiguration({
        appid: this.$store.getters.getAppId
      })
      .then((res) => {
        if (res.code === 200) {
          window.location.href = res.msg; // 修改这行代码，在当前页面跳转
        }
      })
      .catch((error) => {
        console.error("飞书授权失败:", error);
      });
    }
  }
};
</script>

<style scoped>
/* 无需样式 */
</style>


// WEBPACK FOOTER //
// src/views/FeiShuLogin/index.vue